import { Theme, makeStyles } from '@material-ui/core';
import styled from 'styled-components';

export const useStyles = makeStyles((theme: Theme) => ({
  rootDialog: {
    "& .MuiDialog-paper": {
      maxWidth: "678px",
      borderRadius: "8px",
      [theme.breakpoints.down(701)]: {
        margin: 'auto 16px',
      },
      [theme.breakpoints.up(701)]: {
        margin: "auto",
      },
    },
  },
  switchButton: {
    '& .MuiSwitch-switchBase': {
      '&.Mui-checked': {
        '& + .MuiSwitch-track': {
          backgroundColor: "rgba(136, 0, 255, 0.08);",
        },

        '& .MuiSwitch-thumb': {
          backgroundColor: "#8800FF",
        },
      },
      '& .MuiSwitch-thumb': {
        backgroundColor: "#FFFFFF",
      },
      '& + .MuiSwitch-track': {
        backgroundColor: "rgba(136, 0, 255, 0.08);",
      },
      '&.Mui-disabled': {
        cursor: 'not-allowed',
      }
    }
  }
}));



export const ErrorBanner = styled.div`
  padding: 16px;
  margin-top: -16px;
  border-radius: 8px;
  font-size: 18px;
  background: #ff000029;
`;
